export default "__VITE_ASSET__Dimmo3u9__"